<script>
import * as icons from 'vue-feather-icons';

export default {
  functional: true, // maybe you want a functional component. maybe not
  props: {
    icon: { type: String, required: true },
  },
  render(h, ctx) {
    return h(icons[ctx.props.icon]);
  },
};
</script>
